export const environment = {
  production: true,
  config: 'prod',
  environment:'PROD',
  Appcode:'XpressService',
  auth0: {
    domain: 'auth-login.berkley.com', 
    clientId: 'zlfhIIy4G8CuCxnfK9RmbR4TXKvYzqMF' ,
    authorizationParams: {
      redirect_uri:  "https://xp.berkleymarine.com/xps/landing",
      organization:"org_VNngHmY8Ne2gr7kZ",
      audience : "sits_generic_app"
    }
  },
  AuthApiURL: "https://auth-sits.berkley.com:64618/",
  CompanyCode: "BFM",
  AppName:"BFM-APPS-PROD"
};
